import { Box, Container } from "@mui/system";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Slider from "react-slick";
import { Skeleton, Typography } from "@mui/material";
import theme from "../theme/theme";
import { Link as RouterLink } from "react-router-dom";

const PartnersCarousel = ({ loading, page }) => {
  const [partnersData, setPartnersData] = useState([]);
  const [slidesToShow, setSlidesToShow] = useState(5);

  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 1500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
  };

  useEffect(() => {
    // Fetch All Partners and get the ACF field Logo - add it to a Carousel
    axios({
      method: "get",
      url: `${WP_API_Settings.endpoint}wp/v2/partners?acf_format=standard&per_page=100`,
    })
      .then((response) => {
        //randomize the partners
        response.data.sort(() => Math.random() - 0.5);

        setPartnersData(response.data); // Store the data in state
      })
      .catch((error) => {
        console.error("Error fetching partners:", error);
      });
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      let newSlidesToShow;

      if (screenWidth >= 852) {
        newSlidesToShow = 5;
      } else if (screenWidth >= 450) {
        newSlidesToShow = 3;
      } else {
        newSlidesToShow = 2;
      }

      setSlidesToShow(newSlidesToShow);
    };
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      {loading ? (
        <Skeleton
          animation="wave"
          type="rectangle"
          height={"360px"}
          sx={{
            m: 0,
          }}
        />
      ) : partnersData ? (
        <Box
          sx={{
            backgroundColor: "#F0F0F0",
            padding: "60px 4% 60px 4%",
            mt: "-0.5rem",
          }}
        >
          <Container maxWidth="xl">
            {page === "consultancy" ||
              (page === "riskwise" && (
                <Typography
                  sx={{
                    fontSize: "1.3rem",
                    fontWeight: "600",
                    color: "#265DA5",
                    textAlign: "center",
                    width: "100%",
                    marginBottom: "20px",
                  }}
                >
                  Trusted by commercial real estate leaders
                </Typography>
              ))}
            <Slider {...settings}>
              {partnersData.map((partner, index) => {
                return (
                  <Box
                    key={index}
                    sx={{
                      height: "60px",
                      display: "flex!important",
                      alignItems: "center",
                      cursor: "pointer",
                      filter: "grayscale(1)",
                      transition: "filter 0.3s ease-in-out",
                      "&:hover": {
                        filter: "grayscale(0)",
                      },
                    }}
                  >
                    <img
                      src={partner.acf.logo}
                      alt={partner.name}
                      style={{
                        margin: "0 auto",
                        maxWidth: "120px",
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        objectPosition: "center",
                      }}
                    />
                  </Box>
                );
              })}
            </Slider>
            {page === "consultancy" ||
              (page === "riskwise" && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <Typography
                    sx={{
                      textAlign: "center",
                      paddingTop: "40px",
                      margin: "0",
                    }}
                  >
                    Want to know more,
                  </Typography>
                  <Typography
                    component={RouterLink}
                    to="/experience/"
                    sx={{
                      textAlign: "center",
                      paddingTop: "40px",
                      margin: "0",
                    }}
                  >
                    <span style={{ textDecoration: "underline" }}>
                      See client stories
                    </span>
                  </Typography>
                </Box>
              ))}
          </Container>
        </Box>
      ) : null}
    </>
  );
};

export default PartnersCarousel;
